module.exports = __webpack_public_path__ + "static/media/ball_2_0.2c9491d9.mp3";